import { GeneralAPI } from '../apis/GeneralAPI'
import Header from '../components/Header'
import LandingPageWrapper from '../components/HomePage/LandingPageWrapper'
import LandscapingHero from '../components/LandscapingLanding/LandscapingHero'
import SocialProof from '../components/LandscapingLanding/SocialProof'
import CampaignStrategy from '../components/LandscapingLanding/CampaignStrategy'
import WhyOLM from '../components/LandscapingLanding/WhyOLM'
import HowItWorks from '../components/LandscapingLanding/HowItWorks'
import FAQ from '../components/LandscapingLanding/FAQ'
import BookingSection from '../components/LandscapingLanding/BookingSection'
import Footer from '../components/Footer'

export default function Landscaping({ data }) {
    return (
        <LandingPageWrapper sectionSpacing={false} paddingFromTop={false}>
            <Header meta={data?.yoast_head} />
            <LandscapingHero />
            <SocialProof />
            <CampaignStrategy />
            <WhyOLM />
            <HowItWorks />
            <FAQ />
            <BookingSection />
            <Footer />

            <style
                dangerouslySetInnerHTML={{
                    __html: `
                @media (max-width: 640px) {
                    .landscaping-form-grid {
                        grid-template-columns: 1fr !important;
                        padding: 20px !important;
                        gap: 16px !important;
                    }
                    .landscaping-form-footer {
                        justify-content: center !important;
                        text-align: center;
                    }
                    .landscaping-form-footer button {
                        width: 100%;
                    }
                }
            `,
                }}
            />
        </LandingPageWrapper>
    )
}

export async function getStaticProps() {
    let data = {}

    try {
        const page = await GeneralAPI.getPageBySlug('/landscaping')
        data = page ? page[0] || {} : {}
    } catch (e) {
        console.error(e)
    }

    try {
        const { banners } = await GeneralAPI.getACFBanners()
        data.banners = banners
    } catch (e) {
        console.error(e)
    }

    return {
        props: {
            data,
            phoneNumber: '978-893-5890',
        },
        revalidate: 10,
    }
}
